import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classes from './CollectionCover.css';
import Layout from '../../components/Layout/Layout';
import CollectionCover from '../../components/CollectionCover/CollectionCover';
import * as categoriesActions from '../../actions/CategoriesActions';
import * as menuActions from '../../actions/MenuActions';
import { Helmet } from 'react-helmet';

class CategoryCover extends Component {
    componentWillMount() {
        this.props.clearCategory();
    }

    componentDidMount() {
        const { cat } = this.props.match.params;

        this.props.hideAllMenus().then(() => {
            this.props.showTopMenu();
        });

        this.props.getCategory(cat);
    }

    render() {
        const { cat } = this.props.match.params;
        const { category } = this.props.categories;
        const { subcategories } = category;
        const pageTitle = `Benito Santos - ${category.name}`;

        const imageOrigin = `${
            process.env.REACT_APP_API_URL
        }/api/containers/files/download/`;

        const logoURL =
            category.logo && category.logo.length > 0
                ? imageOrigin + category.logo[0].name
                : '';

        const videoURL =
            category.video && category.video.length > 0
                ? imageOrigin + category.video[0].name
                : '';

        const leftImage =
            subcategories[0] && subcategories[0].image
                ? imageOrigin + subcategories[0].image[0].name
                : '';

        const rightImage =
            subcategories[1] && subcategories[1].image
                ? imageOrigin + subcategories[1].image[0].name
                : '';

        return (
            <Layout>
                <Helmet>
                    <title>{pageTitle}</title>
                </Helmet>
                <section className={classes.Container}>
                    {subcategories.length > 0 ? (
                        <CollectionCover
                            logo={logoURL}
                            logoAltText={pageTitle}
                            mainItem={{
                                videoURL: videoURL,
                                title: 'Videos',
                                link: category.videoLink
                            }}
                            leftItem={{
                                cover: leftImage,
                                title: subcategories[0].name,
                                link: `/colecciones/${cat}/${
                                    subcategories[0].slug
                                }`
                            }}
                            rightItem={{
                                cover: rightImage,
                                title: subcategories[1].name,
                                link: `/colecciones/${cat}/${
                                    subcategories[1].slug
                                }`
                            }}
                        />
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '25%' }}>
                            Loading...
                        </div>
                    )}
                </section>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        categories: state.categories
    };
};

const mapDispatchToStore = dispatch => {
    return bindActionCreators(
        {
            ...menuActions,
            ...categoriesActions
        },
        dispatch
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToStore
)(CategoryCover);



// WEBPACK FOOTER //
// ./src/containers/CollectionCover/CollectionCover.js